// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rX4c1FKgXXgjI44ovBCq{border:1px solid var(--black-20);background:var(--background-primary-inverted-primary);border-radius:6px;justify-content:center;align-items:center;width:-webkit-fit-content;width:fit-content;padding:2.5px 3px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `rX4c1FKgXXgjI44ovBCq`
};
export default ___CSS_LOADER_EXPORT___;
